export default __webpack_public_path__ + "static/media/americanExpress_logo.62718970.webp";